export const AppSettingsModule = angular
    .module('app.settings', [])
    .constant('settings', {
        api: {
            cartsREST: 'admin/rest/carts',
            publicCartsREST: 'public/rest/carts',
            abandonedCartsLegacy: 'admin/carts/abandoned',
            abandonedCartsExport: 'admin/carts/abandoned/export',
            adminCategories: 'store/admin/categories',
            analytics: 'admin/analytics',
            apiKeys: 'admin/keys',
            auditlogs: 'store/admin/auditlogs',
            cart: 'admin/carts',
            categories: 'store/admin/categorytree',
            configuration: 'store/admin/configuration',
            coupons: 'store/admin/discounts',
            currencies: 'store/admin/currencies',
            customerBulkUpload: 'admin/data-importer/customers',
            customerBulkUploadStatus: 'admin/data-importer/status/customers',
            customCss: 'store/admin/customcss',
            customDomainStatus: 'admin/customdomains/status',
            customers: 'admin/shoppers',
            customersCount: 'admin/shoppers/count',
            defaultStyleEditorSettings: 'store/admin/defaultstyleeditorsettings',
            discounts: 'admin/discounts',
            discountsREST: 'admin/rest/discounts',
            discountMetrics: 'admin/orders/discountMetrics',
            avalaraCredential: 'taxes/avalaracredential',
            avalaraEntityUseCodes: 'taxes/avatax/entityusecodes',
            avalaraStatus: 'taxes/avatax/status',
            features: 'admin/features',
            fulfillers: 'admin/fulfillers',
            greetingsurvey: 'greetingsurvey',
            imageAnalytics: 'admin/image-analysis',
            imageLinks: 'images',
            images: 'admin/images',
            importJob: 'admin/importjob',
            lessSettings: 'store/admin/lesssettingsfile',
            menus: 'store/admin/menus',
            options: 'store/admin/options',
            orderBulkUpdate: 'admin/orderBulkUpdate',
            orderBulkUpdateStatus: 'admin/orderBulkUpdateStatus',
            orderBulkUpload: 'admin/data-importer/orders',
            orders: 'store/admin/orders',
            ordersMetrics: 'admin/orders/metrics',
            pages: 'admin/contentpages',
            pagesMetrics: 'admin/contentpagemetrics',
            paymentMethod: 'admin/paymentmethod',
            paypalConnect: 'admin/paypal/connect',
            paypalDisconnect: 'admin/paypal/disconnect',
            paypalPrefill: 'admin/paypal/prefill',
            paypalUpsert: 'admin/paypal',
            populateLibrary: 'admin/images/populate',
            postage: 'admin/shipping',
            productBulkUpload: 'admin/importer/csv',
            productBulkUploadStatus: 'admin/importer/status',
            products: 'store/admin/products',
            productExport: 'store/admin/product-export',
            productsMinimal: 'store/admin/products-minimal',
            productsMetrics: 'admin/products/metrics',
            productTaxCodes: 'taxes/avatax/taxcode',
            purchasedextensions: 'store/admin/purchasedextensions',
            purchasedplugins: 'store/admin/purchasedplugins',
            purchasedthemes: 'store/admin/purchasedthemes',
            refreshStorefrontCache: 'admin/storefrontcache/invalidate',
            registerCustomDomain: 'admin/customdomains/register',
            reviews: 'store/admin/reviews',
            searchKey: 'store/admin/searchkeys',
            shippingMethods: 'admin/shippingmethods',
            sitemap: 'admin/sitemap',
            storeAdmin: 'admin/administrators',
            storeAddresses: 'admin/storeaddresses',
            storeAddressesPrimary: 'admin/storeaddresses/primary',
            storeAddress: 'admin/storeaddresses/address',
            storeInformation: 'admin/storeinformation',
            tenantInformation: 'tenantinformation',
            storeInformationCustomDomain: 'admin/storeinformation/customdomain',
            storeSettings: 'store/admin/storesettings',
            stripe: 'admin/storeinformation/stripe',
            stripeCustomerDetails: 'admin/stripecustomerdetails',
            stripeInvoicePayments: 'admin/stripeinvoicepayments',
            stripeInvoicePdf: 'admin/stripeinvoicepdf',
            stripeInvoices: 'admin/stripeinvoices',
            stripeUpcomingInvoice: 'admin/stripeupcominginvoice',
            styleEditorSettings: 'store/admin/styleeditorsettings',
            taxProvider: 'taxes/taxprovider',
            timeout: 4000,
            users: 'store/admin/users',
            validateStripeCoupon: 'stripecoupons',
            verification: 'admin/emails/verification',
            version: 'store/admin/version',
            volusionPaymentsComplete: 'store/admin/paymentkeys/authorizenet',
            volusionPaymentsKYC: 'admin/paymentsmerchantinfo',
            volusionPaymentsTestMode: 'store/admin/authorizenet/settings',
            customFields: 'store/admin/customfields',
            customFieldLinks: 'store/admin/customfieldlinks',
            terms: 'terms',
            acceptedTerms: 'store/admin/acceptedterms',
            storeCredits: 'store/admin/storeCredit'
        },
        language: 'en'
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/settings.provider.js